import React, { Component } from 'react';
import SBottomBar from 'shared/components/BottomBar';
import Screens from 'shared/screens';
import QueryParamsProxy from 'shared/utils/queryParamProxy';
import RouteParamConstants from 'shared/utils/routeParamConstants';
import { ThemeContext } from 'styled-components';
import TimeRemainingText from '../TimeRemainingText';
import audio from 'shared/utils/audio';
import { activateBottomBarAnimation } from 'shared/screens/Missions/utils/missionsPerformance';
import { sendMissionsEvent } from 'shared/screens/Missions/analytics/missionsLogger';
import { MISSIONS_EVENT_TYPES } from 'shared/screens/Missions/constants';
import { shouldChangeTutorialStep, MissionTutorialStepsKeys } from 'shared/utils/tutorial';
import EventsIcon from './components/EventsIcon';
import NotificationBadge from './components/NotificationBadge';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import { pwaStyleAdapter } from '../../utils/mobileSupported';
import LazyImage from '../LazyImage/LazyImage';
import { TAG } from 'shared/constants';
import { BOTTOM_BAR_CONTENT_CONTAINER_ID } from './constants';

const MAX_CHEST_UPDATE_RETRIES = 15;
export default class BottomBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: true,
      showLeftTooltip: false,
      showRightTooltip: false,
      playChestAnimation: false,
      animationWidth: 0,
      animationHeight: window.innerHeight,
    };
    this.chestRef = React.createRef();
  }

  componentDidMount() {
    window.addEventListener('resize', this.resize);
    this.getElements = setInterval(() => {
      if (!this.currencyDisplay) {
        this.currencyDisplay = document.getElementById('CurrencyDisplay');
      }
      if (!this.animation) {
        this.animation = document.getElementById('animationContainer');
      }

      if (this.animation && this.currencyDisplay && this.state.animationWidth === 0) {
        const { animationWidth, animationHeight } = this.getAnimationDimensions();
        this.setState({ animationWidth, animationHeight });
        clearInterval(this.getElements);
      }
    }, 100);
  }

  componentDidUpdate(prevProps, prevState) {
    this.updateDimensions(prevState);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
    clearTimeout(this.updateTimeout);
  }

  updateDimensions(prevState, retries = 0) {
    if (this.animation && this.currencyDisplay) {
      const { animationWidth, animationHeight } = this.getAnimationDimensions();
      if ((animationWidth <= 0 || animationHeight <= 0) && retries <= MAX_CHEST_UPDATE_RETRIES) {
        this.updateTimeout = setTimeout(() => this.updateDimensions(prevState, retries + 1), 50);
      } else {
        if (
          (animationWidth !== prevState.animationWidth || animationHeight !== prevState.animationHeight) &&
          (this.state.animationWidth <= 0 || this.state.animationHeight <= 0)
        ) {
          this.setState({ animationWidth, animationHeight });
        }
      }
    }
  }

  getAnimationDimensions = () => {
    const animationWidth = pwaStyleAdapter(
      window.innerWidth -
        (window.innerWidth -
          (this.animation.getBoundingClientRect().x + this.animation.getBoundingClientRect().width)) -
        this.currencyDisplay.getBoundingClientRect().x -
        30
    );
    const animationHeight = pwaStyleAdapter(window.innerHeight);

    return { animationWidth, animationHeight };
  };

  resize = () => {
    this.currencyDisplay = document.getElementById('CurrencyDisplay');
    this.animation = document.getElementById('animationContainer');
    if (this.animation && this.currencyDisplay) {
      const { animationWidth, animationHeight } = this.getAnimationDimensions();
      this.setState({ animationWidth, animationHeight });
    }
  };

  _sharedWillUpdate = (nextProps, nextState) => {
    if (this.state.visible !== nextState.visible) this.setState({ visible: nextState.visible });
  };

  showTooltip = (key, value) => {
    this.setState({
      [key]: value,
    });
  };

  shouldRunMissionsAnimation = showMissionsIconAnimation =>
    activateBottomBarAnimation(this.props.missionsData) &&
    !this.props.activeTutorial &&
    this.props.missionsAssets &&
    showMissionsIconAnimation;

  handleMissionButton = () => {
    const { activeTutorial, tutorialStep, setTutorialStep, navigation } = this.props;
    if (activeTutorial) {
      sendMissionsEvent(MISSIONS_EVENT_TYPES.MISSIONS_TUTORIAL_NEXT_STEP, { step: tutorialStep });
      shouldChangeTutorialStep(tutorialStep) && setTutorialStep(MissionTutorialStepsKeys.CHECK_GOAL);
    }
    QueryParamsProxy.navigate(navigation, Screens.Missions);
  };

  render() {
    const themeContext = this.context;
    const divider = (
      <LazyImage
        tag={TAG.IMG}
        alt="divider"
        src={assetSource(ASSET_KEY.BOTTOM_BAR_DIVIDER)}
        style={pwaStyleAdapter(themeContext.BottomBar.Divider)}
      />
    );

    return (
      <SBottomBar
        navigation={this.props.navigation}
        sharedWillUpdate={this._sharedWillUpdate}
        render={args => {
          const {
            showModal,
            openChest,
            TIME_LEFT,
            timedBonusHandle,
            canEnterVipRoom,
            isVipRoomUnlocked,
            videoAds,
            appBackground,
            sidebarState,
            setSidebarState,
            claimingBonus,
            unreadMessageCount,
            unreadOfferCount,
            showMissionsButton,
            showEventsButton,
            showMissionsIconAnimation,
            rewardCenterMiddleware,
            isBlockedForMissionsTutorial,
          } = args;
          const isVIPRoom = this.props.navigation.state.routes[this.props.navigation.state.index].key === Screens.VIP;

          const showBadge = unreadMessageCount > 0;
          const showRewardCenterBadge = unreadOfferCount > 0;
          const showPlusOneHundred = unreadMessageCount > 99;

          return (
            <div
              id={BOTTOM_BAR_CONTENT_CONTAINER_ID}
              className={'navBar bottom' + (this.state.visible === false ? ' hide' : ' show')}
              style={{
                ...pwaStyleAdapter(themeContext.BottomBar.BottomBarBackground),
                pointerEvents: isBlockedForMissionsTutorial ? 'none' : 'auto',
                ...(isBlockedForMissionsTutorial && { zIndex: 210 }),
              }}
            >
              <div style={pwaStyleAdapter(themeContext.BottomBar.BottomBarContainer)}>
                <div className="flexBarSection" style={{ flex: 2 }}>
                  {!showEventsButton && <div style={pwaStyleAdapter(themeContext.BottomBar.BarItem)} />}
                  <div
                    style={pwaStyleAdapter(themeContext.BottomBar.BarItem)}
                    onClick={
                      videoAds && (videoAds.timeUntilReset === 0 || videoAds.remaining > 0)
                        ? () => showModal(Screens.VideoAds)
                        : () => showModal(Screens.WatchAndEarnInfo)
                    }
                  >
                    <LazyImage
                      tag={TAG.IMG}
                      alt="Bottom Bar"
                      src={assetSource(ASSET_KEY.WATCH)}
                      draggable="false"
                      style={pwaStyleAdapter(themeContext.BottomBar.WatchAndEarnIcon)}
                    />
                    {videoAds && videoAds.remaining > 0 && (
                      <NotificationBadge
                        textStyle={pwaStyleAdapter(themeContext.BottomBar.NotificationText)}
                        count={videoAds.remaining}
                        theme={pwaStyleAdapter(themeContext.BottomBar.NotificationWatchAndEarn)}
                      />
                    )}
                  </div>
                  {showEventsButton && <EventsIcon navigation={this.props.navigation} />}
                  {divider}
                  <div
                    style={pwaStyleAdapter(themeContext.BottomBar.BarItem)}
                    onClick={() => showModal(Screens.Social)}
                  >
                    <LazyImage
                      tag={TAG.IMG}
                      alt="Bottom Bar"
                      src={assetSource(ASSET_KEY.MAIL)}
                      draggable="false"
                      style={pwaStyleAdapter(themeContext.BottomBar.MailIcon)}
                    />
                    {showBadge && (
                      <NotificationBadge
                        textStyle={pwaStyleAdapter(themeContext.BottomBar.NotificationText)}
                        count={showPlusOneHundred ? '99' : unreadMessageCount}
                        theme={pwaStyleAdapter(themeContext.BottomBar.NotificationMail)}
                      />
                    )}
                  </div>
                </div>
                <div className="flexBarSection" style={{ height: '100%', flex: 1 }}>
                  <>
                    {divider}
                    <div style={pwaStyleAdapter(themeContext.BottomBar.BarItem)} onClick={rewardCenterMiddleware}>
                      <LazyImage
                        tag={TAG.IMG}
                        alt="Bottom Bar"
                        src={assetSource(ASSET_KEY.REWARDS)}
                        draggable="false"
                        style={pwaStyleAdapter(themeContext.BottomBar.RewardCenterIcon)}
                      />
                      {showRewardCenterBadge && (
                        <div style={pwaStyleAdapter(themeContext.BottomBar.RewardCenterBadge)}>{unreadOfferCount}</div>
                      )}
                    </div>
                  </>
                  {divider}
                </div>
                <div className="flexBarSection" style={{ flex: 2 }}>
                  <div
                    style={themeContext.BottomBar.VIPWrapper}
                    onClick={() => {
                      audio.onClick();
                      setSidebarState(!sidebarState);
                      if (isVIPRoom) {
                        QueryParamsProxy.navigate(this.props.navigation, Screens.Home);
                      } else if (!canEnterVipRoom) {
                        QueryParamsProxy.setQueryParams({
                          [RouteParamConstants.PARAM_MODAL]: Screens.VipAccessFlow,
                        });
                      } else {
                        QueryParamsProxy.navigate(this.props.navigation, Screens.VIP);
                      }
                    }}
                  >
                    {!isVIPRoom && (
                      <div className="VIPIconContainer">
                        {!isVipRoomUnlocked && (
                          <LazyImage
                            tag={TAG.IMG}
                            alt="Bottom Bar VIP"
                            src={assetSource(ASSET_KEY.VIP_ENTRY_LOCKED)}
                            draggable="false"
                            style={pwaStyleAdapter(themeContext.BottomBar.VIPIcon)}
                          />
                        )}
                        {appBackground !== 'vipGames' && isVipRoomUnlocked && (
                          <LazyImage
                            tag={TAG.IMG}
                            alt="Bottom Bar VIP"
                            src={assetSource(ASSET_KEY.VIP_ROOM)}
                            draggable="false"
                            style={pwaStyleAdapter(themeContext.BottomBar.VIPIcon)}
                          />
                        )}
                      </div>
                    )}
                    {(isVIPRoom || appBackground === 'vipGames') && (
                      <div className="SlotIconContainer">
                        <LazyImage
                          tag={TAG.IMG}
                          className="SlotIcon"
                          alt="Bottom Bar Slot"
                          src={assetSource(ASSET_KEY.SLOTS)}
                          draggable="false"
                          style={pwaStyleAdapter(themeContext.BottomBar.SlotsIcon)}
                        />
                      </div>
                    )}
                  </div>
                  {divider}
                  <div
                    ref={this.chestRef}
                    style={pwaStyleAdapter(themeContext.BottomBar.BarChestItem)}
                    onClick={
                      openChest
                        ? () => {
                            timedBonusHandle();
                            this.props.startAnimationCallback && this.props.startAnimationCallback();
                            this.setState({ playChestAnimation: true });
                          }
                        : () => {}
                    }
                  >
                    <>
                      {!openChest && !claimingBonus ? (
                        <LazyImage
                          tag={TAG.IMG}
                          style={{
                            ...pwaStyleAdapter(themeContext.BottomBar.ChestClosedBarIcon),
                          }}
                          alt="Bar Item Icon"
                          className={!claimingBonus ? 'TimedChest' : 'TimedChest RotateChest'}
                          src={assetSource(ASSET_KEY.TIMED_BONUS_CHEST_CLOSE)}
                          draggable="false"
                        />
                      ) : (
                        <LazyImage
                          tag={TAG.IMG}
                          style={{
                            ...pwaStyleAdapter(themeContext.BottomBar.ChestOpenBarIcon),
                          }}
                          alt="Bar Item Icon"
                          className={'TimedChest'}
                          src={assetSource(ASSET_KEY.TIMED_BONUS_CHEST_OPEN)}
                          draggable="false"
                        />
                      )}
                    </>
                    <div style={themeContext.BottomBar.TimerWrapper}>
                      <img
                        style={{
                          ...themeContext.BottomBar.TimerBackground,
                          opacity: !TIME_LEFT || TIME_LEFT === 0 ? 1 : 0,
                        }}
                        alt="Timed Bonus Timer"
                        src={assetSource(ASSET_KEY.TIMER_COLLECT_BACKING)}
                        draggable="false"
                      />
                      <img
                        style={{ ...themeContext.BottomBar.TimerBackground, opacity: TIME_LEFT > 0 ? 1 : 0 }}
                        alt="Timed Bonus Timer"
                        src={assetSource(ASSET_KEY.TIMER_WAITING_BACKING)}
                        draggable="false"
                      />
                      {TIME_LEFT > 0 && (
                        <TimeRemainingText style={themeContext.BottomBar.TimerLabel} until={TIME_LEFT} hideOnFinish />
                      )}
                    </div>
                  </div>
                  {showMissionsButton && this.props.missionsData.length > 0 ? (
                    <>
                      {divider}
                      <div
                        className={`BarItem ${
                          this.shouldRunMissionsAnimation(showMissionsIconAnimation) && 'AnimatedIcon'
                        }`}
                        style={{ pointerEvents: 'auto' }}
                        onClick={() => this.handleMissionButton()}
                      >
                        {activateBottomBarAnimation(this.props.missionsData) &&
                          !this.props.activeTutorial &&
                          this.props.missionsAssets && (
                            <NotificationBadge
                              textStyle={pwaStyleAdapter(themeContext.BottomBar.NotificationText)}
                              count="!"
                              theme={pwaStyleAdapter(themeContext.BottomBar.NotificationMission)}
                            />
                          )}
                        <LazyImage
                          tag={TAG.IMG}
                          alt="Bottom Bar"
                          src={assetSource(ASSET_KEY.MISSIONS)}
                          draggable="false"
                          style={pwaStyleAdapter(themeContext.BottomBar.MissionsIcon)}
                        />
                      </div>
                    </>
                  ) : (
                    <div style={pwaStyleAdapter(themeContext.BottomBar.BarItem)} />
                  )}
                </div>
              </div>
            </div>
          );
        }}
      />
    );
  }
}

BottomBar.contextType = ThemeContext;

